import { functions } from 'firebase/app'
import { translate } from '../helpers'

import getCountDataService from '../services/getCountData'


export const getCountData = () => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    const count = await getCountDataService()

    dispatch({
      count,
      type: 'COUNT_DATA',
    })
  } catch (err) {
    dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })
  }
}

export const openDrawer = () => (dispatch) => dispatch({
  type: 'OPEN_DRAWER',
})

export const closeDrawer = () => (dispatch) => dispatch({
  type: 'CLOSE_DRAWER',
})

export const removeSnack = () => (dispatch) => dispatch({
  type: 'REMOVE_SNACK',
})

export const setSnackError = (message) => (dispatch) => dispatch({
  type: 'SNACK_ERROR',
  message: `Error: ${message}`,
})

export const setSnackSuccess = (message) => (dispatch) => dispatch({
  message,
  type: 'SNACK_SUCCESS',
})

export const closeModal = () => (dispatch) => dispatch({
  type: 'MODAL',
  modal: null,
})

export const navigateLogin = (restrictedPathname) => dispatch => dispatch({
  restrictedPathname,
  pathname: '/login',
  type: 'NAVIGATION',
})

export const navigate = (pathname) => (dispatch, getState) => {
  const { app } = getState()

  if (app.uid) {
    return dispatch({
      pathname,
      type: 'NAVIGATION',
    })
  }

  return dispatch(navigateLogin(pathname.includes('login') ? '' : pathname))
}

export const navigateToHome = () => (dispatch) => dispatch({
  type: 'NAVIGATION',
  pathname: '/',
})


export const addScrollFunction = (name, func) => (dispatch) => dispatch({
  name,
  function: func,
  type: 'ADD_SCROLL_FUNCTION',
})


export const removeScrollFunction = (name) => (dispatch) => dispatch({
  name,
  type: 'REMOVE_SCROLL_FUNCTION',
})

export const triggerCounter = (collection) => async (dispatch) => {
  let httpsName = ''
  dispatch({ type: 'REFRESHING', collection })

  try {
    switch (collection) {
      case 'transactions':
        httpsName = 'triggerTransactionCounter'
        break
      case 'orders':
        httpsName = 'triggerOrderCounter'
        break
      case 'users':
        httpsName = 'triggerUserCounter'
        break
      default:
        httpsName = 'triggerShopCounter'
        break
    }

    await functions().httpsCallable(httpsName)()
    dispatch({ type: 'END_REFRESH' })
    dispatch(getCountData())
  } catch (err) {
    console.error(err)
    dispatch({ type: 'REFRESH_ERROR' })
  }
}

export const triggerCreateOrder = (orderData) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await functions().httpsCallable('triggerCreateOrder')(orderData)
    dispatch({
      type: 'SNACK_SUCCESS',
      message: 'La commande a été créé avec succès',
    })
  } catch (err) {
    console.error(err)

    dispatch({
      type: 'SNACK_ERROR',
      message: `Impossible de créer la commande: "${err.message}"`,
    })
  }

  return dispatch({ type: 'UNLOAD' })
}

export const triggerCancelOrder = (orderId) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await functions().httpsCallable('triggerCancelOrder')({ orderId })
    dispatch({
      type: 'SNACK_SUCCESS',
      message: 'La commande a été anulé avec succès',
    })
  } catch (err) {
    console.error(err)

    dispatch({
      type: 'SNACK_ERROR',
      message: `Impossible d'annuler la commande: "${translate(err.message)}"`,
    })
  }

  return dispatch({ type: 'UNLOAD' })
}

export const triggerCancelTransaction = (transactionId) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await functions().httpsCallable('triggerCancelTransaction')({ transactionId })
    dispatch({
      type: 'SNACK_SUCCESS',
      message: 'La transaction a été anulé avec succès',
    })
  } catch (err) {
    console.error(err)

    dispatch({
      type: 'SNACK_ERROR',
      message: `Impossible d'annuler la transaction: "${translate(err.message)}"`,
    })
  }

  return dispatch({ type: 'UNLOAD' })
}
